<div class="progressContainer" *ngIf="progressBar()">
  <p-progressSpinner *ngIf="progressBar()"></p-progressSpinner>
</div>
<div class="layout-container" [ngClass]="containerClass">
  <kanzi-ui-top-bar
    [wereHouseListHide]="false"
    [dataloaderHide]="true"
    [customers]="customers()"
    [customerSelected]="customerSelected()"
    [warehouseRFIDList]="warehouseRootList()"
    [warehouseRFIDMode]="true"
    [warehouseRFIDRootsSelected]="userWarehouseRootSelected()"
    (selectLanguage)="changeLanguage($event)"
    (changeCustomer)="selectCustomer($event)"
    (selectWarehouseRFIDRoot)="onSelectWarehouse($event)"
  ></kanzi-ui-top-bar>
  <kanzi-ui-main-sidebar
    [mainMenuItems]="itemsMenu()"
    [userProfileRfid]="user()"
    [linkDeskHelp]="helpdeskUrl"
    (onLogout)="logoutSession()"
  ></kanzi-ui-main-sidebar>
  <div class="layout-content-wrapper">
    <kanzi-ui-breadcrumb id="breadcrumbStep"></kanzi-ui-breadcrumb>
    <div class="layout-content" id="contentStep">
      <router-outlet></router-outlet>
    </div>
    <kanzi-ui-footer [versionName]="kanziAppVersion()"></kanzi-ui-footer>
  </div>
</div>
<kanzi-apes-alert-voice />
<kanzi-apes-alert />
